// extracted by mini-css-extract-plugin
module.exports = {"container":"bestServices_container__2HpxV","iconText":"bestServices_iconText__AhZxv","icon":"bestServices_icon__2B0UV"};